module.exports = __webpack_public_path__ + "img/1.8087ce46.svg";